module.exports = __webpack_public_path__ + "static/Google_Arts_And_Culture_clip-c931fab16d5f11a007cf8548a863849b.mp4";